import React, { useRef, useEffect } from "react";

const POINTS = 60;
const SPEED = 0.18;

function random(min, max) {
  return Math.random() * (max - min) + min;
}

export default function AnimatedBackground() {
  const canvasRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    function resizeCanvas() {
      // Fülle die gesamte Seite, nicht nur den Viewport
      canvas.width = window.innerWidth;
      canvas.height = Math.max(window.innerHeight, document.body.scrollHeight);
    }
    resizeCanvas();

    let w = canvas.width;
    let h = canvas.height;

    let points = Array.from({ length: POINTS }).map(() => ({
      x: random(0, w),
      y: random(0, h),
      r: random(1.1, 2.2),
      dx: random(-SPEED, SPEED),
      dy: random(-SPEED, SPEED),
      pulse: random(0, Math.PI * 2)
    }));

    function animate() {
      w = canvas.width;
      h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      ctx.globalAlpha = 0.18;
      ctx.fillStyle = "#fff";
      points.forEach(p => {
        p.pulse += 0.03;
        const pr = p.r + Math.sin(p.pulse) * 0.7;
        ctx.beginPath();
        ctx.arc(p.x, p.y, pr, 0, 2 * Math.PI);
        ctx.fill();

        p.x += p.dx;
        p.y += p.dy;
        if (p.x < 0 || p.x > w) p.dx *= -1;
        if (p.y < 0 || p.y > h) p.dy *= -1;
      });
      requestAnimationFrame(animate);
    }
    animate();

    window.addEventListener("resize", resizeCanvas);
    return () => window.removeEventListener("resize", resizeCanvas);
  }, []);

  return (
    <>
      {/* Fallback-Background für die ganze Seite */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          minHeight: "100%",
          zIndex: -2,
          pointerEvents: "none",
          background: "radial-gradient(ellipse at 80% 70%, #1a1a1d 0%, #0a0a0c 100%)"
        }}
      />
      {/* Animierter Canvas-Background */}
      <canvas
        ref={canvasRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          minHeight: "100%",
          zIndex: -1,
          pointerEvents: "none",
          background: "transparent"
        }}
      />
    </>
  );
}
